module.exports = __webpack_public_path__ + "media/images/lb/010-e857b1577acfaf1c81476a869e5ac99e.svg";